// src/config.js
const config = {
  //host_backend: "http://192.168.100.11:5000",
  host_backend: "https://osrati.xyz/api",
  API_KEY: "your_api_key_here",
  DEBUG_MODE: true
};

export default config;